import axios from '../../axios-config'
/**
 * GET
 * /twg/api/v1/bank/account
 * getAccounts
 */
export const getAccounts = () => {
  return axios.get('/twg/api/v1/bank/account')
}
